export default "__VITE_ASSET__e6b0f814__"